import { List } from "semantic-ui-react";

import ACL_RELATIONSHIPS from "acl-relationships";
import NoteForm from "components/forms/NoteForm";
import { ManualActivityModal as _ManualActivityModal } from "components/modals/ManualActivityModal";
import withRoleCheck from "components/hocs/withRoleCheck";
import { AuditLogFilters } from "components/views/AuditLogFilters";
import { AuditLogQuickFilters } from "components/views/AuditLogQuickFilters";

const ManualActivityModal = withRoleCheck(_ManualActivityModal, [
  ACL_RELATIONSHIPS.textMessage.create,
  ACL_RELATIONSHIPS.campaignTargetEmail.create,
  ACL_RELATIONSHIPS.campaignTargetCall.create,
]);

const NoteFormBlock = withRoleCheck("div", [ACL_RELATIONSHIPS.activity.create]);

/**
 * The controls above the Activity Log: the quick filters and Filters panel
 * always, and — only when `allowManualActivity` is set — the manual-activity
 * button and the note composer. A note is a manual activity entry, so a
 * read-only log (`allowManualActivity={false}`) offers neither.
 *
 * Rendered as List.Items inside the log's List, because `.tabView` sizes its
 * `> .item` children and the composer must match the width of the entries.
 * `onLogChange` refreshes the log after a manual activity or a note is added.
 */
export function AuditLogHeader({
  modelId,
  modelType,
  slug,
  allowManualActivity,
  categories,
  refetchCategories,
  filters,
  filterKeys,
  queryParams,
  filtersLoading,
  filtersFailed,
  onApplyFilters,
  onLogChange,
}) {
  return (
    <>
      <List.Item>
        <div className="tw:gap-2 tw:flex tw:items-center tw:justify-end">
          {allowManualActivity && (
            <div className="tw:mr-auto tw:*:mr-0!">
              <ManualActivityModal
                modelId={modelId}
                modelType={modelType}
                onSuccess={onLogChange}
              />
            </div>
          )}
          {!filtersFailed && (
            <AuditLogQuickFilters
              modelType={modelType}
              filters={filters}
              filterKeys={filterKeys}
              queryParams={queryParams}
              onApply={onApplyFilters}
              isLoading={filtersLoading}
            />
          )}
          <AuditLogFilters
            filters={filters}
            queryParams={queryParams}
            modelType={modelType}
            onApply={onApplyFilters}
            isLoading={filtersLoading}
            isError={filtersFailed}
          />
        </div>
      </List.Item>
      {allowManualActivity && (
        <List.Item>
          <NoteFormBlock className="tw:flex tw:py-1">
            <NoteForm
              modelType={modelType}
              modelId={modelId}
              slug={slug}
              categories={categories}
              updateCategories={refetchCategories}
              onSuccess={onLogChange}
            />
          </NoteFormBlock>
        </List.Item>
      )}
    </>
  );
}
